import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// Import styles of packages that you've installed.
// All packages except `@mantine/hooks` require styles imports
import "@mantine/core/styles.css";

/**
 * 🧠 What’s Going On
- requestIdleCallback is a browser API that schedules low-priority tasks when the browser is idle.
- It’s supported in Chrome, Edge, Firefox, but not in Safari on iOS or macOS.
- If your code calls it without a fallback, Safari throws a ReferenceError, which can halt rendering — especially if it’s used early in your app (e.g. in hydration or routing logic).

This code is a fallback so that if the user is on a mac env, it will fall back to this function
 */
if (typeof window.requestIdleCallback === "undefined") {
  window.requestIdleCallback = function (cb) {
    return setTimeout(cb, 1);
  };
  window.cancelIdleCallback = function (id) {
    clearTimeout(id);
  };
}
if (process.env.NODE_ENV === "development") {
  window.addEventListener(
    "error",
    (event) => {
      if (
        event?.message?.includes("ResizeObserver loop completed") ||
        event?.message?.includes("ResizeObserver loop limit exceeded")
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true, // capture phase so we intercept before React's error handler
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const msg = String(event.reason?.message || event.reason || "");
      if (
        msg.includes("ResizeObserver loop completed") ||
        msg.includes("ResizeObserver loop limit exceeded")
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
